unable to read source [project]/packages/shared/src/schemas/studio.ts